module.exports = __webpack_public_path__ + "om.c34bf82d2ca800cf89a9.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/om.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/om.svg
// module chunks = styles